module.exports = __webpack_public_path__ + "img/1.dd836228.png";